// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".merge-request-auto-merge-info__wrapper[data-v-856b8d5e]{border:1px solid var(--border-color);border-radius:.25rem}.merge-request-auto-merge-info__cancel[data-v-856b8d5e]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
